import type {
  IMachineContext,
  ICommonComponentConfig,
  INextEvent,
  IYardageSelectionEvent,
  TInputTypes,
} from '@/types';
import type { usePlayFlowState } from '@/stores/playFlow';
import type { useGeneralState } from '@/stores/general';

export type TMetaFuncInput = {
  send: Function;
  playFlowState: ReturnType<typeof usePlayFlowState>;
  generalState: ReturnType<typeof useGeneralState>;
  payload: INextEvent | IYardageSelectionEvent;
  context: IMachineContext;
};

export interface IStateMetaData {
  component: TInputTypes;
  componentConfiguration: ICommonComponentConfig;
  onNext: (param: TMetaFuncInput) => void;
  onBack: (param: TMetaFuncInput) => void;
}

export enum TWorkflowType {
  COIN = 'COIN_TOSS',
  KICKOFF = 'KICKOFF',
  REGULAR_PLAY = 'REGULAR_PLAY',
  PUNT = 'PUNT',
  PAT = 'PAT',
  FIELD_GOAL = 'FIELD_GOAL',
}

export enum TMachineStates {
  GAME_SELECTION = 'GAME_SELECTION',
  PLAYER_PREVIEW = 'PLAYER_PREVIEW',
  SELECT_ROLE = 'SELECT_ROLE',
  IDLE = 'IDLE',
  SELECT_WORKFLOW = 'SELECT_WORKFLOW',
  INIT_COIN = 'INIT_COIN_TOSS_WORKFLOW',
  INIT_KICKOFF = 'INIT_KICKOFF',
  INIT_REGULAR_PLAY = 'INIT_REGULAR_PLAY',
  INIT_FIELD_GOAL = 'INIT_FIELD_GOAL',
  PENALTY = 'PENALTY',
  REF_EVENT = 'REF_EVENT',
  CONFIRMATION = 'CONFIRMATION',
  PAT = 'PAT',
  UNDER_REVIEW = 'UNDER_REVIEW',
  CHAINS = 'CHAINS',
  CHALLENGE = 'CHALLENGE',
  INIT_PUNT = 'INIT_PUNT',
  SELECT_SIDE = 'SELECT_SIDE',
  GAME_OVER = 'GAME_OVER',
  HANDLE_YARDAGE_TOGGLES = 'HANDLE_YARDAGE_TOGGLES',
  YARDAGE_SELECTION = 'YARDAGE_SELECTION',
}

export enum TMachineEvents {
  BACK = 'BACK',
  TO_IDEL = 'TO_IDEL',
  ROLE_SELECTED = 'ROLE_SELECTED',
  GAME_SELECTED = 'GAME_SELECTED',
  START_COIN = 'START_COIN_TOSS_WORKFLOW',
  PLAY_COMPLETED = 'PLAY_COMPLETED',
  TOV_SELECTED = 'TOV_SELECTED',
  PENALTY_SELECTED = 'PENALTY_SELECTED',
  REGULAR_PLAY_SELECTED = 'REGULAR_PLAY_SELECTED',
  RESUME_REGULAR_PLAY = 'RESUME_REGULAR_PLAY',
  RESUME_KICKOFF = 'RESUME_KICKOFF',
  RESUME_PAT = 'RESUME_PAT',
  KICKOFF_SELECTED = 'KICKOFF_SELECTED',
  CONFIRMED = 'CONFIRMED',
  TO_PAT = 'TO_PAT',
  ON_UNDER_REVIEW = 'ON_UNDER_REVIEW',
  ON_CHAINS = 'ON_CHAINS',
  ON_CHALLENGE = 'ON_CHALLENGE',
  BACK_TO_REVIEW = 'BACK_TO_REVIEW',
  BACK_TO_CHAIN = 'BACK_TO_CHAIN',
  BACK_TO_CHALLANGE = 'BACK_TO_CHALLANGE',
  BACK_TO_PENALTY = 'BACK_TO_PENALTY',
  BACK_TO_REF = 'BACK_TO_REF',
  FIELD_GOAL_SELECTED = 'FIELD_GOAL_SELECTED',
  TO_PUNT = 'TO_PUNT',
  BACK_TO_YARDAGE_SELECTION = 'BACK_TO_YARDAGE_SELECTION',
  TO_HANDLE_YARDAGE_TOGGLE = 'TO_HANDLE_YARDAGE_TOGGLE',
  BACK_TO_HANDLE_YARDAGE = 'BACK_TO_HANDLE_YARDAGE',
  ON_YARDAGE_TOGGLE_INP_SELECTION = 'ON_YARDAGE_TOGGLE_INP_SELECTION',
  BACK_TO_SAME = 'BACK_TO_SAME',
  ON_REF_EVENT = 'ON_REF_EVENT',
  CHOOSE_SIDES = 'CHOOSE_SIDES',
  CONFIRM_WITH_SAFTEY = 'CONFIRM_WITH_SAFTEY',
  POST_PENALTY_YARDAGE = 'POST_PENALTY_YARDAGE',
  BACK_TO_HANDLE_YARDAGE_TOGGLE = 'BACK_TO_HANDLE_YARDAGE_TOGGLE',
  PENALTY_DECLINED = 'PENALTY_DECLINED',
  PENALTY_DECLINED_TO_CONFIRM = 'PENALTY_DECLINED_TO_CONFIRM',
  ON_SELECT_POSSESSION = 'ON_SELECT_POSSESSION',
}

export enum TMachineGlobalEvents {
  TO_COIN_TOSS_GLOBAL = 'TO_COIN_TOSS_GLOBAL',
  TO_REGULAR_PLAY_GLOBAL = 'TO_REGULAR_PLAY_GLOBAL',
  TO_IDLE_GLOBAL = 'TO_IDLE_GLOBAL',
  TO_PAT_GLOBAL = 'TO_PAT_GLOBAL',
}

export enum TMachineActions {
  UPDATE_CONTEX = 'UPDATE_CONTEX',
  SET_NEXT_STATE_INPUT = 'SET_NEXT_STATE_INPUT',
  COPY_PREV_STATE_INPUT = 'COPY_PREV_STATE_INPUT',
  UNSET_NEXT_STATE_INPUT = 'UNSET_NEXT_STATE_INPUT',
  SAVE_PLAY = 'SAVE_PLAY',
  CLEAR_YARDAGE_TOGGLE_DATA = 'CLEAR_YARDAGE_TOGGLE_DATA',
  RESET_CONTEXT = 'RESET_CONTEXT',
  CLEAR_PLAY = 'CLEAR_PLAY',
}
